/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowWithText = {
	init: function($section) {

    const attempt = ($section.data('jsSlideshowWithText-init-attempt') || 0) + 1;
    $section.data('jsSlideshowWithText-init-attempt', attempt);

    // Safety: avoid infinite retries if something is fundamentally broken.
    if (attempt > 5) return;

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowWithText = $.extend(this, window.PXUTheme.getSectionData($section));

    const textTransition = this.text_transition;

    // Selectors
    const $imageSlideshowEl = $section.find('[data-image-slideshow]').removeClass('is-hidden');
    const $textSlideshowEl = $section.find('[data-text-slideshow]').removeClass('is-hidden');

    const shouldAutoplay = this.image_slideshow_speed > 0;
    const autoplayMs = this.image_slideshow_speed * 1000;
    let isSyncing = false;

    // If Theme Editor reloads the same section, make init idempotent.
    if ($imageSlideshowEl.data('flickity')) {
      $imageSlideshowEl.flickity('destroy');
    }
    if ($textSlideshowEl.data('flickity')) {
      $textSlideshowEl.flickity('destroy');
    }

    // Flickity plugin may not be ready yet if scripts load out of order.
    if (typeof $imageSlideshowEl.flickity !== 'function' || typeof $textSlideshowEl.flickity !== 'function') {
      setTimeout(() => window.PXUTheme.jsSlideshowWithText.init($section), 250);
      return;
    }

    let $imageSlideshow;
    try {
      $imageSlideshow = $imageSlideshowEl.flickity({
      contain: true,
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: shouldAutoplay ? autoplayMs : false,
      // Use window.arrowShape to avoid ReferenceError if init runs
      // before `window.arrowShape` is assigned.
      arrowShape: window.arrowShape
      });
    } catch (e) {
      // Retry shortly if init fails due to missing dependencies/race conditions.
      console.error('jsSlideshowWithText init error (image)', e);
      setTimeout(() => window.PXUTheme.jsSlideshowWithText.init($section), 250);
      return;
    }

    // Prevent autoplay from advancing while we attach the sync handlers.
    if (shouldAutoplay) {
      try {
        $imageSlideshow.flickity('pausePlayer');
      } catch (e) {
        // Ignore if pausePlayer isn't available.
      }
    }

    let $textSlideshow;
    try {
      $textSlideshow = $textSlideshowEl.flickity({
      autoplay: false,
      contain: true,
      imagesLoaded: true,
      lazyload: 4,
      prevNextButtons: false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: false,
      on: {
        ready: function () {
          const $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content').first();
          if ($currentTextSlide.length) {
            window.PXUTheme.animation.slideTransition($currentTextSlide, textTransition);
          }
        }
      }
      });
    } catch (e) {
      // Retry shortly if init fails due to missing dependencies/race conditions.
      console.error('jsSlideshowWithText init error (text)', e);
      setTimeout(() => window.PXUTheme.jsSlideshowWithText.init($section), 250);
      return;
    }

    // Initial sync:
    // Force-sync the text slider to whatever slide the image slider is currently on.
    const imageFlickity = $imageSlideshowEl.data('flickity');
    const initialIndex = imageFlickity ? imageFlickity.selectedIndex : 0;
    isSyncing = true;
    $textSlideshow.flickity('select', initialIndex, true, true);
    isSyncing = false;

    const $initialTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content').first();
    if ($initialTextSlide.length) {
      window.PXUTheme.animation.slideTransition($initialTextSlide, textTransition);
    }

    // Resume autoplay after initial sync.
    if (shouldAutoplay) {
      try {
        $imageSlideshow.flickity('playPlayer');
      } catch (e) {
        // Ignore if playPlayer isn't available.
      }
    }

    $imageSlideshow.on('change.flickity', function (event, index) {
      if (isSyncing) return;
      isSyncing = true;
      $textSlideshow.flickity('select', index, true, true);

      const $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content').first();
      if ($currentTextSlide.length) {
        window.PXUTheme.animation.slideTransition($currentTextSlide, textTransition);
      }
      isSyncing = false;
    });

    $textSlideshow.on('change.flickity', function (event, index) {
      if (isSyncing) return;
      isSyncing = true;
      $imageSlideshow.flickity('select', index, true, false);
      isSyncing = false;
    });

    $section.find('.flickity-button').wrapAll('<div class="flickity-buttons-container"></div>');

    // Mark init as successful.
    $section.data('jsSlideshowWithText-init-attempt', 0);


  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

    // Resize flickity when the slider is settled
    $slider.on( 'settle.flickity', function() {
      $slider.flickity('resize');
    }, 500);

  },
	unload: function($section) {
    const $imageSlideshowEl = $section.find('[data-image-slideshow]');
    const $textSlideshowEl = $section.find('[data-text-slideshow]');

    // Theme editor can reload the same section multiple times.
    // Destroy Flickity instances so we don't end up with duplicate/partial state.
    if ($imageSlideshowEl.data('flickity')) {
      $imageSlideshowEl.flickity('destroy');
    }
    if ($textSlideshowEl.data('flickity')) {
      $textSlideshowEl.flickity('destroy');
    }

    $section.find('.flickity-button').unwrap();
	}
}

/******/ })()
;